export default __webpack_public_path__ + "static/media/icon-ecosystem.890de907.svg";